module.exports = __webpack_public_path__ + "static/media/uber-logo.58db7596.png";